export default __webpack_public_path__ + "static/media/recent_activity_3.6a386451.jpg";